module.exports = __webpack_public_path__ + "img/100.88431647.png";